import worldTopo from '../assets/topo/world-110m.json';
import americasTopo from '../assets/topo/americas-110m.json';
import southAmericaTopo from '../assets/topo/south-america-110m.json';
import latinAmericaTopo from '../assets/topo/latin-america-110m.json';
import europeTopo from '../assets/topo/europe-110m.json';

export const REGION_MAP_CONFIG = {
  World: {
    geography: worldTopo,
    projection: { scale: 147, center: [0, 20] },
    zoomCenter: [0, 20],
  },
  Americas: {
    geography: americasTopo,
    projection: { scale: 220, center: [-85, 15] },
    zoomCenter: [-85, 15],
  },
  'South America': {
    geography: southAmericaTopo,
    projection: { scale: 450, center: [-58, -25] },
    zoomCenter: [-58, -25],
  },
  'Latin America': {
    geography: latinAmericaTopo,
    projection: { scale: 280, center: [-75, 5] },
    zoomCenter: [-75, 5],
  },
  Europe: {
    geography: europeTopo,
    projection: { scale: 650, center: [20, 55] },
    zoomCenter: [20, 55],
  },
};

export const DEFAULT_REGION = 'South America';

export function getRegionConfig(region) {
  return REGION_MAP_CONFIG[region] ?? REGION_MAP_CONFIG[DEFAULT_REGION];
}
